<p-tabView [(activeIndex)]="selectedIndex" (onChange)="handleChange($event)">
  <div style="width: 100%; text-align: right; padding-right: 5px; height: 5px;" class="formTools">
    <button id="btnSearch" aria-hidden="true" *ngIf="!_SIP" style="top: -40px; width: 10vw; height: 35px" icon="fa fa-search" pButton
            label="Search" [disabled]="_SIP" (click)="triggerSearch();"></button>

    <button id="btnSearch1" *ngIf="_SIP" style="top: -40px; width: 10vw; height: 35px" icon="fa fa-spinner fa-pulse fa-fw" pButton   type="button"  label="Search" (click)="triggerSearch();"></button>
    <p-dropdown #reportSelector [style]="{'width':'20vw', 'top':'-40px', 'text-align':'left'}" id="reportSelector" [(ngModel)]="reportModel" name="reportSelector" [options]="reportList"
                placeholder="Select a report..." [disabled]="_SIP" (onChange)="setActive($event)"></p-dropdown>
    <button  id="btnAllData" style="top: -40px; width: 11vw; height: 35px" icon="fa fa-file-zip-o" pButton type="button" label="Download"
            (click)="downloadfile()" [disabled]="_SIP" title="Downloads a bulk unfiltered file for this report">
    </button>
    <button id="btnResetForm" aria-hidden="true" style="top: -40px; width: 15vw; height: 35px" pButton icon="fa fa-eraser"  type="button" label="Clear Form" (click)="resetForm()" [disabled]="_SIP">
    </button>
  </div>
  <p-tabPanel header="Search Criteria" [headerStyle]="{'background': selectedIndex === 0 ? '#DCEDC8' : '', 'font-size':'1em'}">
    <form  [formGroup]="advSrchFormGrp" #advSrchForm>
      <div>
          <p-accordion>
              <p-accordionTab [selected]="true" data="AccountInformation">
                <p-header>
                  <div> Account Information
                    <app-chips [chipName]="'Accounts'" [chipValues]="getCtrlVal(['accounts'])" (clearChip)="chipClear($event,['accounts'])"></app-chips>
                    <app-chips [chipName]="'SPN'" [chipValues]="getCtrlVal(['spnMin','spnMax'])" (clearChip)="chipClear($event,['spnMin','spnMax'])"></app-chips>
                    <app-chips [chipName]="'Account Type'" [chipValues]="getCtrlVal(['accountType'])" (clearChip)="chipClear($event,['accountType'])"></app-chips>
                    <app-chips [chipName]="'Appraisal Type'" [chipValues]="getCtrlVal(['appraisalType'])" (clearChip)="chipClear($event,['appraisalType'])"></app-chips>
                    <app-chips [chipName]="'Owner Name'" [chipValues]="getCtrlVal(['ownerName'])" (clearChip)="chipClear($event,['ownerName'])"></app-chips>
                    <app-chips [chipName]="'Property Value'" [chipValues]="getCtrlVal(['propertyValueMin','propertyValueMax'])" (clearChip)="chipClear($event,['propertyValueMin','propertyValueMax'])"></app-chips>
                    <app-chips [chipName]="'Neighborhood'" [chipValues]="getCtrlVal(['neighborhood'])" (clearChip)="chipClear($event,['neighborhood'])"></app-chips>
                    <app-chips [chipName]="'LEA'" [chipValues]="getCtrlVal(['lea'])" (clearChip)="chipClear($event,['lea'])"></app-chips>                    
                   </div>
                </p-header>
                <div class="formFlexFive" *ngIf="!usingFile">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Account #:</label>
                    <input #accounts formControlName="accounts" placeholder="" pattern="^([RMCP][\d]{7}[,]?)+$" class="ui-inputgroup-addon"/>
                    <button pButton icon="fa fa-file-text-o" type="button" style="width: 33px" (click)="setFileFlag($event)" title="upload a file of account numbers"></button>
                  </div>
                </div>
                <div class="formFlexFive" *ngIf="usingFile">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Account #:</label>
                    <input class="inputfile" #accountFile formControlName="accountFile" type="file" accept=".csv, .txt" (change)="purifyImportedAccounts(accountFile)" value=""/>
                    <button pButton class="btn btn-xs" icon="fa fa-ban" (click)="setFileFlag($event)" title="Cancel"></button>
                    <span class="inputhelper">* accepts .txt and .csv</span>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">State Parcel #:</label>
                    <p-inputMask mask="9999-999-99-999" (keyup)="setMaxSPN($event)" formControlName="spnMin" class="noUi-bookend left number-input"></p-inputMask>
                    <span>to</span>
                    <p-inputMask mask="9999-999-99-999" formControlName="spnMax" class="noUi-bookend right number-input"></p-inputMask>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Account Type:</label>
                    <p-multiSelect #accountType formControlName="accountType" [options]="this.options['account_types']" [style]="{'width':'250px'}" [maxSelectedLabels]="0" optionLabel="label" dataKey="value" [filter]="false">
                    </p-multiSelect>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Appraisal Type:</label>
                    <p-multiSelect #appraisalType formControlName="appraisalType" [options]="[{label:'Personal', value:'Personal'}, {label:'Real', value:'Real'}, {label:'State', value:'State'}]" [style]="{'width':'250px'}" [maxSelectedLabels]="0"
                                    optionLabel="label" dataKey="value" [filter]="false"></p-multiSelect>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Owner Name:</label>
                    <input formControlName="ownerName" type="text" size="33" class="ui-inputgroup-addon noUi-bookend left"/>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Property Value:</label>
                    <input assrNumber formatType="currency" (apply)="applyFormatted($event)" type="text" formControlName="propertyValueMin"
                            class="ui-inputgroup-addon noUi-bookend left number-input" maxlength="12">
                    <span>to</span>
                    <input assrNumber formatType="currency" (apply)="applyFormatted($event)" type="text" formControlName="propertyValueMax"
                            class="ui-inputgroup-addon noUi-bookend right number-input" maxlength="12">
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Neighborhood:</label>
                    <p-multiSelect #neighborhood formControlName="neighborhood" [options]="filteredNeighborhoods" dataKey="name"
                          optionLabel="name" [style]="{'width':'150px'}" [maxSelectedLabels]="0" [filter]="true" resetFilterOnHide="true">
                    </p-multiSelect>                    
                    <label class="formLabel">Neighborhood Ext:</label>                    
                      <p-multiSelect #neighborhood_extension formControlName="neighborhood_extension" [options]="filteredNeighborhoodExtensions" optionLabel="label" dataKey="value" [filter]="true" [style]="{'width':'100px'}" [maxSelectedLabels]="0" resetFilterOnHide="true">
                      </p-multiSelect>
                  </div>
                </div>

                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">LEA:</label>
                    <p-multiSelect #lea formControlName="lea" dataKey="value" optionLabel="label" [filter]="true" [options]="options['leas']" resetFilterOnHide="true"
                          [style]="{'width':'200px'}" [maxSelectedLabels]="0">
                    </p-multiSelect>                    
                  </div>
                </div>                

              </p-accordionTab>
              <p-accordionTab data="BuildingAttributes">
                <p-header>
                  <div> Building Attributes
                    <app-chips [chipName]="'Square Footage'" [chipValues]="getCtrlVal(['squareFootageMin','squareFootageMax'])" (clearChip)="chipClear($event,['squareFootageMin','squareFootageMax'])"></app-chips>
                    <app-chips [chipName]="'Style'" [chipValues]="getCtrlVal(['builtAs'])" (clearChip)="chipClear($event,['builtAs'])"></app-chips>
                    <app-chips [chipName]="'Quality'" [chipValues]="getCtrlVal(['quality'])" (clearChip)="chipClear($event,['quality'])"></app-chips>
                    <app-chips [chipName]="'Building Use'" [chipValues]="getCtrlVal(['occupancyCode'])" (clearChip)="chipClear($event,['occupancyCode'])"></app-chips>
                    <app-chips [chipName]="'Year Built'" [chipValues]="getCtrlVal(['yearBuiltMin','yearBuiltMax'])" (clearChip)="chipClear($event,['yearBuiltMin','yearBuiltMax'])"></app-chips>
                    <app-chips [chipName]="'Basement SqFt'" [chipValues]="getCtrlVal(['basementSQFTMin','basementSQFTMax'])" (clearChip)="chipClear($event,['basementSQFTMin','basementSQFTMax'])"></app-chips>
                    <app-chips [chipName]="'Finished Basement'" [chipValues]="getCtrlVal(['basementFinish'])" (clearChip)="chipClear($event,['basementFinish'])"></app-chips>
                    <app-chips [chipName]="'Walk-Out Basement'" [chipValues]="getCtrlVal(['basementWalkOut'])" (clearChip)="chipClear($event,['basementWalkOut'])"></app-chips>
                  </div>
                </p-header>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Square Footage:</label>
                    <input type="text" assrNumber (apply)="applyFormatted($event)" formatType="number" maxlength="7" formControlName="squareFootageMin"
                            #squareFootageMin class="ui-inputgroup-addon noUi-bookend left number-input"/>
                    <span>to</span>
                    <input type="text" assrNumber (apply)="applyFormatted($event)" formatType="number" maxlength="7" formControlName="squareFootageMax"
                            #squareFootageMax class="ui-inputgroup-addon noUi-bookend right number-input"/>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Style / Built As:</label>
                    <p-multiSelect #builtAs formControlName="builtAs" [options]="options['building_styles']" [style]="{'width':'300px'}" dataKey="code" optionLabel="description" [maxSelectedLabels]="0" resetFilterOnHide="true"></p-multiSelect>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Quality:</label>
                    <p-multiSelect #quality formControlName="quality" [filter]="false" [options]="options['quality']" [style]="{'width':'200px'}" [maxSelectedLabels]="0"></p-multiSelect>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Building Use:</label>
                    <p-multiSelect #occupancyCode formControlName="occupancyCode" [options]="options['building_uses']" dataKey="code" optionLabel="description" [style]="{'width':'375px'}" [maxSelectedLabels]="0" resetFilterOnHide="true"></p-multiSelect>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Year Built:</label>
                    <input type="text" assrNumber formatType="year" [min]="minYear" [max]="maxYear" maxlength="7" formControlName="yearBuiltMin" [placeholder]="'>= '+ minYear"
                            class="ui-inputgroup-addon noUi-bookend left number-input" maxlength="4" (apply)="applyFormatted($event)" (change)="yearBuiltValidity($event, 'yearBuiltMin')"/>
                    <span>to</span>
                    <input type="text" assrNumber formatType="year" [min]="maxYear" [max]="maxYear" maxlength="7" formControlName="yearBuiltMax" [placeholder]="'<= '+ maxYear"
                            class="ui-inputgroup-addon noUi-bookend right number-input" maxlength="4" (apply)="applyFormatted($event)" (change)="yearBuiltValidity($event, 'yearBuiltMax')"/>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Basement SqFt:</label>
                    <input type="text" assrNumber (apply)="applyFormatted($event)" maxlength="7" formControlName="basementSQFTMin" #basementSQFTMin class="ui-inputgroup-addon noUi-bookend left number-input"/>
                    <span>to</span>
                    <input type="text" assrNumber (apply)="applyFormatted($event)" maxlength="7" formControlName="basementSQFTMax" #basementSQFTMax class="ui-inputgroup-addon noUi-bookend right number-input"/>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Finished Basement:</label>
                    <p-dropdown formControlName="basementFinish" [style]="{'width':'225px'}"
                                [options]="[{label:'Finished AND Unfinished', value:null}, {label:'Finished Only', value:true}, {label:'Unfinished Only', value:false}]" placeholder="Choose">
                      <ng-template let-item pTemplate="selectedItem">
                        <span>{{item.label}}</span>
                      </ng-template>
                      <ng-template let-item pTemplate="item">
                        <span>{{item.label}}</span>
                      </ng-template>
                    </p-dropdown>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Walk-Out Basement:</label>
                    <p-dropdown formControlName="basementWalkOut" [style]="{'width':'245px'}"
                                [options]="[{label:'Walkout AND Non-Walk-Out', value:null}, {label:'Walkout Only', value:true}, {label:'Non-Walk-Out Only', value:false}]" placeholder="Choose">
                      <ng-template let-item pTemplate="selectedItem">
                        <span>{{item.label}}</span>
                      </ng-template>
                      <ng-template let-item pTemplate="item">
                        <span>{{item.label}}</span>
                      </ng-template>
                    </p-dropdown>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab data="ParcelValuation">
                <p-header>
                  <div> Sales Info
                    <app-chips [chipName]="'Sale Price'" [chipValues]="getCtrlVal(['salePriceMin','salePriceMax'])" (clearChip)="chipClear($event,['salePriceMin','salePriceMax'])"></app-chips>
                    <app-chips [chipName]="'Sale Date'" [chipValues]="getCtrlVal(['saleDateMin','saleDateMax'])" (clearChip)="chipClear($event,['saleDateMin','saleDateMax'])"></app-chips>
                    <app-chips [chipName]="'Recording Number'" [chipValues]="getCtrlVal(['saleRecordingNumber'])" (clearChip)="chipClear($event,['saleRecordingNumber'])"></app-chips>
                    <app-chips [chipName]="'Deed Type'" [chipValues]="getCtrlVal(['deedType'])" (clearChip)="chipClear($event,['deedType'])"></app-chips>
                    <app-chips [chipName]="'Grantor'" [chipValues]="getCtrlVal(['grantor'])" (clearChip)="chipClear($event,['grantor'])"></app-chips>
                    <app-chips [chipName]="'Grantee'" [chipValues]="getCtrlVal(['grantee'])" (clearChip)="chipClear($event,['grantee'])"></app-chips>
                    <app-chips [chipName]="'Improved'" [chipValues]="getCtrlVal(['vacant_improved'])" (clearChip)="chipClear($event,['vacant_improved'])"></app-chips>                    
                    <app-chips [chipName]="'Multi-Parcel'" [chipValues]="getCtrlVal(['multi_parcel'])" (clearChip)="chipClear($event,['multi_parcel'])"></app-chips>
                    <app-chips [chipName]="'Qualified Sale'" [chipValues]="getCtrlVal(['qualified_sale'])" (clearChip)="chipClear($event,['qualified_sale'])"></app-chips>
                  </div>
                </p-header>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Sale Price:</label>
                    <input type="text" assrNumber formatType="currency" maxlength="12" (apply)="applyFormatted($event)" formControlName="salePriceMin" #salePriceMin
                            class="ui-inputgroup-addon noUi-bookend left number-input"/>
                    <span>to</span>
                    <input type="text" assrNumber formatType="currency" maxlength="12" (apply)="applyFormatted($event)" formControlName="salePriceMax" #salePriceMax class="ui-inputgroup-addon noUi-bookend right number-input"/>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Sale
                      Date:
                    </label>
                    <p-inputMask formControlName="saleDateMin" mask="99/99/9999" placeholder=">= {{minSaleDate.toDateString()}}" slotChar="mm/dd/yyyy" class="noUi-bookend left number-input"
                                  (change)="saleDateValidity($event, 'saleDateMin')"></p-inputMask>
                    <span>to</span>
                    <p-inputMask formControlName="saleDateMax" mask="99/99/9999" placeholder="<= {{maxSaleDate.toDateString()}}" slotChar="mm/dd/yyyy" class="noUi-bookend right number-input"
                                  (change)="saleDateValidity($event, 'saleDateMax')"></p-inputMask>
        
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Recording Number:</label>
                    <input #saleRecordingNumber formControlName="saleRecordingNumber" [style]="{'width':'500px'}" class="ui-inputgroup-addon noUi-bookend left"/>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Deed Type:</label>
                    <p-multiSelect #deed_type formControlName="deedType" [options]="this.options['deed_types']" dataKey="value"
                                    optionLabel="label" [style]="{'width':'375px'}" [maxSelectedLabels]="0" [filter]="true" resetFilterOnHide="true">
                    </p-multiSelect>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Grantor:</label>
                    <input #grantor formControlName="grantor" [style]="{'width':'500px'}" class="ui-inputgroup-addon noUi-bookend left"/>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Grantee:</label>
                    <input #grantee formControlName="grantee" [style]="{'width':'500px'}" class="ui-inputgroup-addon noUi-bookend left"/>
                  </div>
                </div>

                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Vacant/Improved:</label>
                    <p-dropdown formControlName="vacant_improved" [style]="{'width':'245px'}"
                                [options]="this.options['vacant_improved']" placeholder="Choose">
                      <ng-template let-item pTemplate="selectedItem">
                        <span>{{item.label}}</span>
                      </ng-template>
                      <ng-template let-item pTemplate="item">
                        <span>{{item.label}}</span>
                      </ng-template>
                    </p-dropdown>
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Multi-Parcel:</label>
                    <p-dropdown formControlName="multi_parcel" [style]="{'width':'245px'}"
                                [options]="this.options['multi_parcel']" placeholder="Choose">
                      <ng-template let-item pTemplate="selectedItem">
                        <span>{{item.label}}</span>
                      </ng-template>
                      <ng-template let-item pTemplate="item">
                        <span>{{item.label}}</span>
                      </ng-template>
                    </p-dropdown>                   
                  </div>
                </div>
                <div class="formFlexFive">
                  <div class="ui-inputgroup">
                    <label class="formLabel">Qualified Sale:</label>
                    <p-dropdown formControlName="qualified_sale" [style]="{'width':'245px'}"
                                [options]="this.options['qualified_sale']" placeholder="Choose">
                      <ng-template let-item pTemplate="selectedItem">
                        <span>{{item.label}}</span>
                      </ng-template>
                      <ng-template let-item pTemplate="item">
                        <span>{{item.label}}</span>
                      </ng-template>
                    </p-dropdown>
                  </div>
                </div>

              </p-accordionTab>
              <p-accordionTab data="SubdivisionAttributes">
              <p-header>
                <div> Subdivision Attributes
                  <app-chips [chipName]="'Subdivision Name'" [chipValues]="getCtrlVal(['subDivision'])" (clearChip)="chipClear($event,['subDivision'])"></app-chips>
                  <app-chips [chipName]="'Filing Description'" [chipValues]="getCtrlVal(['sub_filings'])" (clearChip)="chipClear($event,['sub_filings'])"></app-chips>
                  <app-chips [chipName]="'Block'" [chipValues]="getCtrlVal(['block'])" (clearChip)="chipClear($event,['block'])"></app-chips>
                  <app-chips [chipName]="'Lot'" [chipValues]="getCtrlVal(['lot'])" (clearChip)="chipClear($event,['lot'])"></app-chips>
                  <app-chips [chipName]="'Tract'" [chipValues]="getCtrlVal(['tract'])" (clearChip)="chipClear($event,['tract'])"></app-chips>
                  <app-chips [chipName]="'Recording Number'" [chipValues]="getCtrlVal(['recording_number'])" (clearChip)="chipClear($event,['recording_number'])"></app-chips>                  
                </div>
              </p-header>
              <div class="formFlexFive">
                <div class="ui-inputgroup">
                  <label class="formLabel">Subdivision Name:</label>
                  <p-multiSelect #subDivision formControlName="subDivision" dataKey="number" optionLabel="name" [filter]="true" [options]="this.options['subdivisions']" resetFilterOnHide="true"
                                  [style]="{'width':'450px'}" [maxSelectedLabels]="0">
                  </p-multiSelect>
                </div>
              </div>
              <div class="formFlexFive">
                <div class="ui-inputgroup">
                  <label class="formLabel">Filing Description:</label>
                  <p-multiSelect #sub_filings formControlName="sub_filings" [options]="filteredFilings" [style]="{'width':'400px'}" [maxSelectedLabels]="0" resetFilterOnHide="true">
                  </p-multiSelect>
                </div>
              </div>
              <div class="formFlexFive">
                <div class="ui-inputgroup">
                  <label class="formLabel">Block:</label>
                  <input #block formControlName="block" [style]="{'width':'150px'}" maxlength="20" size="20" class="ui-inputgroup-addon noUi-bookend left"/>
                </div>
              </div>
              <div class="formFlexFive">
                <div class="ui-inputgroup">
                  <label class="formLabel">Lot:</label>
                  <input formControlName="lot" #lotMin class="ui-inputgroup-addon noUi-bookend left"/>
                </div>
              </div>
              <div class="formFlexFive">
                <div class="ui-inputgroup">
                  <label class="formLabel">Tract:</label>
                  <input formControlName="tract" #lotMin class="ui-inputgroup-addon noUi-bookend left"/>
                </div>
              </div>
              <div class="formFlexFive">                
                <div class="ui-inputgroup">
                  <label class="formLabel">Recording Number:</label>
                  <input formControlName="recording_number" #recording_number class="ui-inputgroup-addon noUi-bookend left"/>
                </div>                
              </div>
            </p-accordionTab>
              <p-accordionTab data="TaxInformation">
                  <p-header>
                    <div> Tax Authority Information
                      <app-chips [chipName]="'Tax District'" [chipValues]="getCtrlVal(['taxDistrict'])" (clearChip)="chipClear($event,['taxDistrict'])"></app-chips>
                      <app-chips [chipName]="'Tax Authority'" [chipValues]="getCtrlVal(['taxAuthority'])" (clearChip)="chipClear($event,['taxAuthority'])"></app-chips>
                    </div>
                  </p-header>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">Tax District:</label>
                      <p-autoComplete #taxDistrict formControlName="taxDistrict" [suggestions]="filteredDistricts" (completeMethod)="filterDistricts($event)" [multiple]="true" [minLength]="2" [dropdown]="false" dataKey="value" field="label" placeholder="Type for options" forceSelection="true"
                                      emptyMessage="No results...">
                        <ng-template let-sub pTemplate="item">
                          <div>{{sub.label}}</div>
                        </ng-template>
                      </p-autoComplete>
                    </div>
                  </div>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">Tax Authority:</label>
                      <p-multiSelect #taxAuthority formControlName="taxAuthority" [options]="filteredAuthorities" [style]="{'width':'375px'}"
                                      [filter]="true" [maxSelectedLabels]="0" dataKey="value" optionLabel="label" resetFilterOnHide="true">
                        <ng-template let-opt pTemplate="item">
                          <span>{{opt.value.value}} - {{opt.label}}</span>
                        </ng-template>
                      </p-multiSelect>
                    </div>
                  </div>
                </p-accordionTab>
              <p-accordionTab data="Address">
                  <p-header>
                    <div> Address
                      <app-chips [chipName]="'Street Number'" [chipValues]="getCtrlVal(['streetNumberMin','streetNumberMax'])" (clearChip)="chipClear($event,['streetNumberMin','streetNumberMax'])"></app-chips>
                      <app-chips [chipName]="'Street Name'" [chipValues]="getCtrlVal(['streetName'])" (clearChip)="chipClear($event,['streetName'])"></app-chips>
                      <app-chips [chipName]="'Cities'" [chipValues]="getCtrlVal(['city'])" (clearChip)="chipClear($event,['city'])"></app-chips>
                      <app-chips [chipName]="'ZipCode'" [chipValues]="getCtrlVal(['zipCode'])" (clearChip)="chipClear($event,['zipCode'])"></app-chips>
                    </div>
                  </p-header>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">Street Number:</label>
                      <div class="ui-inputgroup">
                        <input formControlName="streetNumberMin" #streetNumberMin class="ui-inputgroup-addon noUi-bookend left number-input" type="number" [min]="0" [max]="999"/>
                        <span>to</span>
                        <input formControlName="streetNumberMax" #streetNumberMax class="ui-inputgroup-addon noUi-bookend right number-input" type="number" [min]="0" [max]="999999"/>
                      </div>
                    </div>
                  </div>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">Street Name:</label>
                      <p-autoComplete #streetName formControlName="streetName" [suggestions]="filteredStreets" (completeMethod)="filterStreets($event)" [minLength]="4" [dropdown]="false" [style]="{'width':'475px'}" placeholder="Type for options" dataKey="value" field="label" forceSelection="true" emptyMessage="No results...">
                      </p-autoComplete>
                    </div>
                  </div>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">Cities:</label>
                      <p-multiSelect #city formControlName="city" [options]="options['cities']" [style]="{'width':'375px'}" [maxSelectedLabels]="0" optionLabel="label" dataKey="value" resetFilterOnHide="true">
                      </p-multiSelect>
                    </div>
                  </div>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">ZipCode:</label>
                      <p-multiSelect #zipCode formControlName="zipCode" [options]="this.options['zip_codes']" [style]="{'width':'210px'}" [maxSelectedLabels]="0" resetFilterOnHide="true">
                        <ng-template let-opt>
                          <div>{{opt.label}}</div>
                        </ng-template>
                      </p-multiSelect>
                    </div>
                  </div>
                </p-accordionTab>
              <p-accordionTab data="LandAttributes">
                  <p-header>
                    <div> Land Attributes
                      <app-chips [chipName]="'Township'" [chipValues]="getCtrlVal(['township'])" (clearChip)="chipClear($event,['township'])"></app-chips>
                      <app-chips [chipName]="'Section'" [chipValues]="getCtrlVal(['section'])" (clearChip)="chipClear($event,['section'])"></app-chips>
                      <app-chips [chipName]="'Range'" [chipValues]="getCtrlVal(['range'])" (clearChip)="chipClear($event,['range'])"></app-chips>
                      <app-chips [chipName]="'Land Use'" [chipValues]="getCtrlVal(['landUse'])" (clearChip)="chipClear($event,['landUse'])"></app-chips>
                      <app-chips [chipName]="'Land Attribute'" [chipValues]="getCtrlVal(['landAttribute'])" (clearChip)="chipClear($event,['landAttribute'])"></app-chips>
                      <app-chips [chipName]="'Acres'" [chipValues]="getCtrlVal(['acresMin','acresMax'])" (clearChip)="chipClear($event,['acresMin','acresMax'])"></app-chips>
                    </div>
                  </p-header>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">Township:</label>
                      <p-dropdown #township formControlName="township" [style]="{'width':'150px'}" [options]="options['township']" placeholder="Choose.." dataKey="value">
                        <ng-template let-opt pTemplate="item">
                          <div>{{opt.label}}</div>
                        </ng-template>
                      </p-dropdown>
                    </div>
                  </div>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">Section:</label>
                      <p-dropdown #section formControlName="section" [style]="{'width':'150px'}" [options]="options['section']" placeholder="Choose">
                        <ng-template let-opt pTemplate="item">
                          <div>{{opt.label}}</div>
                        </ng-template>
                      </p-dropdown>
                    </div>
                  </div>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">Range:</label>
                      <p-dropdown #range formControlName="range" [style]="{'width':'150px'}" [options]="options['range']" placeholder="Choose">
                        <ng-template let-opt pTemplate="item">
                          <div>{{opt.label}}</div>
                        </ng-template>
                      </p-dropdown>
                    </div>
                  </div>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">Land Use:</label>
                      <p-dropdown #landUse formControlName="landUse" [style]="{'width':'475px'}" [options]="filteredLandUses" dataKey="value" optionLabel="label" placeholder="Choose">
                        <ng-template let-item pTemplate="selectedItem">
                          <span>{{item.value.value}} - {{item.label}}</span>
                        </ng-template>
                        <ng-template let-item pTemplate="item">
                          <span>{{item.value.value}} - {{item.label}}</span>
                        </ng-template>
                      </p-dropdown>
                    </div>
                  </div>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">Land Attribute:</label>
                      <p-multiSelect #landAttribute formControlName="landAttribute" [options]="options['land_attributes']" [style]="{'width':'375px'}" [maxSelectedLabels]="0" dataKey="code" optionLabel="description" resetFilterOnHide="true"></p-multiSelect>
                    </div>
                  </div>
                  <div class="formFlexFive">
                    <div class="ui-inputgroup">
                      <label class="formLabel">Acres:</label>
                      <input type="number" min="0" value="0" step="0.01" (apply)="applyFormatted($event)" formControlName="acresMin" #acresMin class="ui-inputgroup-addon noUi-bookend left number-input"/>
                      <span>to</span>
                      <input type="number" min="0" value="0" step="0.01" (apply)="applyFormatted($event)" formControlName="acresMax" #acresMax class="ui-inputgroup-addon noUi-bookend right number-input"/>
                    </div>
                  </div>
                </p-accordionTab>
            </p-accordion>  
      </div>
    </form>
  </p-tabPanel>
  <p-tabPanel header="Results" [headerStyle]="{'background': selectedIndex === 1 ? '#DCEDC8' : ''}">
    <div class="loader" *ngIf="_SIP==true"><img src="assets/images/loader.png"/>
    </div>
      <app-search-results [exportDisabled]="exportDisabled" *ngIf="resultObject.hasResults; else noResults"></app-search-results>
      <ng-template #noResults>
        <p *ngIf="_SIP==false">No results to display</p>
      </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Map" [headerStyle]="{'background': selectedIndex === 2 ? '#DCEDC8' : ''}">
    <div class="flex-container">
      <div style="width: 19%; font-weight: bold; text-align: center; height: 600px; border: 1px solid #186634; margin: 10px 10px 10px 0; padding: 0;" *ngIf="!resultObject?.hasResults">
        0 Accounts
        <hr style="width: 100%">
        Account
        <hr>
      </div>
      <div class="column1" *ngIf="resultObject?.hasResults">
        <div>
          <app-search-short-results (uniqueAcc)="uniqueAccEmitter($event)"></app-search-short-results>
        </div>
      </div>
  
      <div class="column2">
        <app-map-container [resultObject]="uniqueAccounts"
                           (extentChangedEvent)="mapExtentChanged($event)"
                           (mapMoveEvent)="triggerSearch()"  
        ></app-map-container>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>



